import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'
import {
  type UserSearchRequestEntity,
  UserSearchRequestSchema
} from '@/core/infrastructure/schemas/users/core/UserInputSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export default class UserSearchRequest {
  readonly q: string | null
  readonly roles: UserRole.Values[]
  readonly genders: UserGender.Values[]
  readonly blocked: boolean | null
  readonly emailVerified: boolean | null

  constructor(request: UserSearchRequestEntity) {
    this.q = request.q ?? null
    this.roles = request.roles ?? []
    this.genders = request.genders ?? []
    this.blocked = request.blocked ?? null
    this.emailVerified = request.emailVerified ?? null
  }

  /**
   * Transforme en query params utilisables par Axios
   */
  toQueryParams(): Record<string, any> {
    return Object.fromEntries(
      Object.entries(this).filter(([_, v]) => v !== null && v !== undefined)
    )
  }

  public static create(data: unknown): UserSearchRequest {
    return EntityValidator.validateAndCreate(
      UserSearchRequestSchema,
      data,
      UserSearchRequest,
      'UserSearchRequest'
    )
  }
}